import {Link} from 'react-router'
import {useEffect, useRef} from 'react'
import {Oculus} from '@product/ovid/components/Oculus/Oculus'
import {UserBlock} from '@product/ovid/components/UserBlock/UserBlock'

// 'packs' is the live nav target; 'feed'/'atelier' are accepted for the PARKED rooms'
// call sites (those routes are left in place, not promoted) so they keep type-checking.
type OvidNav = 'packs' | 'feed' | 'atelier' | null

interface HeaderProps {
    /** 'fixed' densifies on scroll (overlays the hero); 'static' is opaque + sticky. */
    variant?: 'fixed' | 'static'
    current?: OvidNav
}

/**
 * OvidHeader — the maison header (.ov-header). Shared across landing, feed and
 * atelier. The fixed variant overlays the hero and takes [data-solid] once the
 * page is scrolled; the static variant is opaque from the start.
 */
export function Header({variant = 'fixed'}: HeaderProps) {
    const ref = useRef<HTMLElement>(null)

    useEffect(() => {
        if (variant !== 'fixed') return
        const el = ref.current
        if (!el) return
        const onScroll = () => el.toggleAttribute('data-solid', window.scrollY > 120)
        window.addEventListener('scroll', onScroll, {passive: true})
        onScroll()
        return () => window.removeEventListener('scroll', onScroll)
    }, [variant])

    return (
        <header ref={ref} className={`ov-header${variant === 'static' ? ' ov-header--static' : ''}`}>
            <Link to="/" className="ov-header__brand" aria-label="Ovid — home">
                <Oculus size={30} />
                <span className="ov-wordmark">Ovid<span className="ov-pt">.</span></span>
            </Link>
            <div className="ov-header__actions">
                {/* Signed out: "Enter" link. Signed in: the chosen muse + avatar dropdown (Your muse /
                    Make a muse of your own / Sign out). No nav: the pack pages are behind the surface cut
                    (`core/products/ovidSurfaceGate.ts`), the wall at `/` is the product. */}
                <UserBlock />
            </div>
        </header>
    )
}

export default Header
